import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.ETICKET_SERVER_PREFIX}/reserve-seats`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getCounterByEmployeeId: () => `${RESOURCE_ENDPOINT}/get-counter-info`,
    getByWhere: () => `${RESOURCE_ENDPOINT}/getByWhere`,
    create: () => `${RESOURCE_ENDPOINT}`,
    createManual: () => `${RESOURCE_ENDPOINT}/manual-store`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    deSelect: () => `${RESOURCE_ENDPOINT}/deselect-seat`,
    manualDeSelect: () => `${RESOURCE_ENDPOINT}/manual-deselect-seat`,
}

export default class ReserveSeatsApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public getCounterByEmployeeId = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCounterByEmployeeId();
        return HttpService.get(url, params, headers);
    }

    public getByWhere = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getByWhere();
        return HttpService.get(url, params, headers);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public createManual = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.createManual();
        return HttpService.post(url, payload, params, headers);
    }

    public deSelect = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.deSelect();
        return HttpService.post(url, payload, params, headers);
    }

    public manualDeSelect = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.manualDeSelect();
        return HttpService.post(url, payload, params, headers);
    }


    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

}
